module.exports = __webpack_public_path__ + "static/media/researcher.8d49f815.svg";